module.exports = __webpack_public_path__ + "img/logo_ftv.6439aed0.svg";